import { connect } from 'react-redux';

import Component from './D2AAcceleratedLearningTable.component';
import { getStudentsList } from '../+store/aToF';

const mapStateToProps = (state) => ({
  profile: state.modules.Auth.auth.profile,
});

const mapDispatchToProps = (dispatch) => ({
  handleGetStudentsList: (orgId, path, rowLabel, indicatorLabel) => {
    dispatch(getStudentsList(orgId, path, rowLabel, indicatorLabel));
  },
});

const Container = connect(mapStateToProps, mapDispatchToProps)(Component);

export default Container;
